import Avatar from 'design-system/avatar'
import { AvatarSizes } from 'design-system/avatar/src/resources/Avatar.enum'
import { resolveUserAvatarUrl } from 'helpers/avatar.helper'
import { IUserMonitoringModel } from 'models/monitoring.model'
import { IParticipantModel } from 'models/participant.model'
import styles from './ParticipantCourseResults.module.scss'

interface IProps {
  participant?: IParticipantModel
  monitoringUser: IUserMonitoringModel
  courseName: string
}

export const ParticipantCourseResultsHeader = ({
  participant,
  monitoringUser,
  courseName,
}: IProps) => {
  const participantName =
    participant?.fullName ||
    [participant?.name, participant?.lastname].filter(Boolean).join(' ') ||
    [monitoringUser.name, monitoringUser.lastname].filter(Boolean).join(' ') ||
    '—'

  const avatar = participant?.avatar || monitoringUser.avatar

  return (
    <div className={styles.header}>
      <Avatar
        sizes={AvatarSizes.XExtraLarge}
        className={styles.headerAvatar}
        src={resolveUserAvatarUrl(avatar)}
        useOriginalImage
      />
      <div className={styles.headerInfo}>
        <h1 className={styles.headerName}>{participantName}</h1>
        <p className={styles.courseName}>
          Curso: <span className={styles.courseNameValue}>{courseName}</span>
        </p>
      </div>
    </div>
  )
}

export default ParticipantCourseResultsHeader
